import React from 'react';

const Loader = () => {
    return (
        <section className="mt-5 pt-4 loader-align">
            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/loader-gif.gif" alt="loader"></img>
            <p>LOADING COLORBOT...</p>
        </section>
    );
};

export default React.memo(Loader);
